import { Provider as ReduxProvider } from "react-redux";
import AuthContextProvider from "./contexts/AuthContext/AuthContext";
import RootNavigator from "./navigation";
import { store } from "./redux/store";
import * as Sentry from "@sentry/react";
import "./styles.css";
import ToastContextProvider from "./contexts/ToastContext/ToastContext";
import { Toast } from "./components";
import "./assets/css/extras.css";
import { BrowserRouter } from "react-router-dom";

import { useEffect } from "react";
import { NavigationProvider } from "./contexts/NavigationContext/NavigationContext";

Sentry.init({
  enabled: process.env.NODE_ENV !== "development",
  environment: process.env.REACT_APP_ENV,
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
});

const HotJar = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.innerHTML = `
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:5130568,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
};

function App() {
  return (
    <ReduxProvider store={store}>
      <AuthContextProvider>
        <ToastContextProvider>
          <Toast />
          <HotJar />
          <BrowserRouter>
            <NavigationProvider>
              <RootNavigator />
            </NavigationProvider>
          </BrowserRouter>
        </ToastContextProvider>
      </AuthContextProvider>
    </ReduxProvider>
  );
}

export default App;
